import React from 'react';
import { Footer } from '../../containers/index';
import { Navbar, CTA } from '../../components';
import GoogleMapComponent from './GoogleMapComponent';
import PlaceList from './PlaceList';
import '../../App.css';

const Index = () => (
  <div className="App">
    <div className="gradient__bg">
      <Navbar />
    </div>
    <div className="gpt3__possibility section__padding" id="possibility">
      {/* <div className="gpt3__possibility-image">
        <h1>Filter button</h1>
      </div>
      <div className="gpt3__possibility-content">
        <GoogleMapComponent />
      </div> */}
      <GoogleMapComponent />
    </div>
    <CTA />
    <PlaceList />
    <Footer />
  </div>
);

export default Index;
